export const CompanySessionName = '@LI.COMPANY';
export const UserSessionName = '@LI.USER';
export const RoleSessionName = '@LI.ROLE';
export const TokenSessionName = '@LI.TOKEN';